import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
const listContainerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08
    }
  }
};
const listItemVariants = {
  hidden: {
    opacity: 0,
    y: 15
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.35
    }
  }
};
export function AudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section className="w-full bg-cream-100 py-16 md:py-24" ref={ref} data-id="element-1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-14" data-id="element-3">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-navy-900 mb-4" data-id="element-4">
            ¿Es para ti?
          </h2>

          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-5" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6">
          {/* For */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white rounded-xl border border-cream-200 p-6 sm:p-8" data-id="element-7">
            <h3 className="font-heading text-2xl font-bold text-navy-900 mb-6" data-id="element-8">
              Esto es para ti si…
            </h3>
            <motion.ul className="space-y-4" role="list" variants={listContainerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-9">
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-10">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-11" />
                <span className="font-body text-gray-700" data-id="element-12">
                  Tienes visa aprobada (EB-2 NIW, E-2, L-1, O-1, etc.) y te
                  mudas en los próximos 90 días.
                </span>
              </motion.li>
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-13">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-14" />
                <span className="font-body text-gray-700" data-id="element-15">
                  Viajas con hijos y necesitas asegurar vivienda y escuela de
                  inmediato.
                </span>
              </motion.li>
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-16">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-17" />
                <span className="font-body text-gray-700" data-id="element-18">
                  Eres inversionista y quieres evitar desperdiciar capital en
                  logística ineficiente.
                </span>
              </motion.li>
              <motion.li variants={listItemVariants} className="flex items-start gap-3" data-id="element-19">
                <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-20" />
                <span className="font-body text-gray-700" data-id="element-21">
                  Valoras el orden y quieres llegar a EE.UU. con el control
                  total de la situación.
                </span>
              </motion.li>
            </motion.ul>
          </motion.div>

          {/* Not for */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white rounded-xl border border-cream-200 p-6 sm:p-8" data-id="element-22">
            <h3 className="font-heading text-2xl font-bold text-navy-900 mb-6" data-id="element-23">
              Esto NO es para ti si…
            </h3>
            <ul className="space-y-4" role="list" data-id="element-24">
              <li className="flex items-start gap-3" data-id="element-25">
                <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-26" />
                <span className="font-body text-gray-700" data-id="element-27">
                  Aún no tienes un proceso migratorio iniciado o aprobado.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-28">
                <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-29" />
                <span className="font-body text-gray-700" data-id="element-30">
                  Prefieres improvisar y no te importa gastar más dinero por
                  falta de planificación.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-31">
                <XCircleIcon className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-32" />
                <span className="font-body text-gray-700" data-id="element-33">
                  Eres turista o no planeas establecer tu residencia permanente
                  en el país.
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}